import makeRequest from 'api/'

export const getTaskTags = async () => {
  return await makeRequest({
    method: 'get',
    url: '/task-tag',
  })
}

export const createTaskTag = async (data) => {
  return await makeRequest({
    method: 'post',
    url: '/task-tag',
    data,
  })
}

export const updateTaskTags = async (id, data) => {
  return await makeRequest({
    method: 'patch',
    url: `/task-tag/${id}`,
    data,
  })
}

export const attachTagToTask = async (taskId, tagId) => {
  return await makeRequest({
    method: 'post',
    url: `/task-tag/${taskId}/${tagId}`,
  })
}

export const deleteTagToTask = async (taskId, tagId) => {
  return await makeRequest({
    method: 'delete',
    url: `/task-tag/${taskId}/${tagId}`,
  })
}
